import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-black" data-id="element-116">
      <div className="max-w-3xl mx-auto text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-white/5 backdrop-blur-sm p-5 md:p-6 rounded-2xl border border-white/10 flex flex-col items-center" data-id="element-118">
          <div className="mb-3" data-id="element-119">
            <ShieldCheckIcon className="w-10 h-10 text-orange" data-id="element-120" />
          </div>

          <h2 className="text-xl md:text-2xl font-black text-white tracking-tight mb-3" data-id="element-121">
            <span className="underline decoration-orange decoration-4 underline-offset-4" data-id="element-122">
              Garantía 30 Días
            </span>
            : 100% Satisfacción
          </h2>

          <p className="text-sm md:text-base text-white/80 font-medium leading-snug max-w-2xl" data-id="element-123">
            Es simple, todo el riesgo está de mi lado. Si no es el sistema más
            completo que viste en tu vida, enviame un correo electrónico y te
            devolveré el{' '}
            <span className="underline decoration-orange decoration-2 underline-offset-2 font-bold text-white" data-id="element-124">
              100% de tu dinero sin preguntas
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}